import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const routeToTitleKey = [
  { pattern: /^\/login$/, key: 'login' },
  { pattern: /^\/register$/, key: 'register' },
  { pattern: /^\/verify-email$/, key: 'verifyEmail' },
  { pattern: /^\/forgot-password$/, key: 'forgotPassword' },
  { pattern: /^\/reset-password$/, key: 'resetPassword' },
  { pattern: /^\/helpers\/[^/]+$/, key: 'helperProfile' },
  { pattern: /^\/helpers$/, key: 'helpers' },
  { pattern: /^\/groups\/[^/]+$/, key: 'groupDetail' },
  { pattern: /^\/groups$/, key: 'groups' },
  { pattern: /^\/jobs\/new$/, key: 'createJob' },
  { pattern: /^\/jobs\/[^/]+$/, key: 'jobDetail' },
  { pattern: /^\/jobs$/, key: 'jobs' },
  { pattern: /^\/services\/new$/, key: 'createService' },
  { pattern: /^\/services\/[^/]+$/, key: 'serviceDetail' },
  { pattern: /^\/services$/, key: 'services' },
  { pattern: /^\/dashboard$/, key: 'dashboard' },
  { pattern: /^\/bookings\/[^/]+$/, key: 'bookingDetail' },
  { pattern: /^\/bookings$/, key: 'bookings' },
  { pattern: /^\/notifications$/, key: 'notifications' },
  { pattern: /^\/settings\/notifications$/, key: 'notificationSettings' },
  { pattern: /^\/availability$/, key: 'availability' },
  { pattern: /^\/admin$/, key: 'admin' },
  { pattern: /^\/care-seekers\/[^/]+$/, key: 'careSeekerProfile' },
  { pattern: /^\/economy$/, key: 'economy' },
  { pattern: /^\/stripe\/onboarding/, key: 'stripeReturn' },
  { pattern: /^\/$/, key: 'home' },
];

export default function usePageTitle() {
  const { pathname } = useLocation();
  const { t } = useLanguage();

  useEffect(() => {
    const match = routeToTitleKey.find((r) => r.pattern.test(pathname));
    const titleKey = match ? match.key : 'home';
    const title = t(`pageTitle.${titleKey}`);
    document.title = title || 'Vennli';
  }, [pathname, t]);
}
